import { AbstractControl } from "@angular/forms";

export function PasswordNoSymbolValidator(control: AbstractControl): any {
  const newPassword = control.value;
  const symbolCharacters = "!\"#$%&'()*+,-./:;<=>?@[]^_`{|}~";

  let atLeast1SymbolCharacter = false;
  for (let i = 0; i < newPassword.length; i++) {
    if (symbolCharacters.indexOf(newPassword[i]) >= 0) {
      atLeast1SymbolCharacter = true;
    }
  }

  if (!atLeast1SymbolCharacter) {
    return { passwordNoSymbol: true };
  }

  return null;
}
